"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZSubmitPrizeChoiceRequest = exports.ZPlayerSelect = exports.ZDrawTypeSelect = exports.ZDrawSelect = exports.ZTicketEntrySelect = exports.ZPrizeOrderProductInsert = exports.ZPrizeOrderProductSelect = exports.ZPrizeOrderInsert = exports.ZPrizeOrderSelect = exports.ZPrizeWinInsert = exports.ZPrizeWinSelect = exports.ZAdditionalInfo = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZAdditionalInfo = zod_1.z.record(zod_1.z.string(), zod_1.z.string());
exports.ZPrizeWinSelect = zodSchemas_generated_1.zodSelectPrizeWin.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPrizeWin.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    chosenAt: zod_1.z.coerce.date().nullable(),
}));
exports.ZPrizeWinInsert = zodSchemas_generated_1.zodInsertPrizeWin;
exports.ZPrizeOrderSelect = zodSchemas_generated_1.zodSelectPrizeOrder.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPrizeOrder.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    confirmedAt: zod_1.z.coerce.date().nullable(),
    additionalInfoFromPlayer: exports.ZAdditionalInfo,
}));
exports.ZPrizeOrderInsert = zodSchemas_generated_1.zodInsertPrizeOrder.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodInsertPrizeOrder.shape, {
    additionalInfoFromPlayer: exports.ZAdditionalInfo,
}));
exports.ZPrizeOrderProductSelect = zodSchemas_generated_1.zodSelectPrizeOrderProduct.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPrizeOrderProduct.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    awardedAt: zod_1.z.coerce.date().nullable(),
}));
exports.ZPrizeOrderProductInsert = zodSchemas_generated_1.zodInsertPrizeOrderProduct;
exports.ZTicketEntrySelect = zodSchemas_generated_1.zodSelectTicketEntry.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectTicketEntry.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    entry: dbJsonModels_1.ZEntryLine,
}));
exports.ZDrawSelect = zodSchemas_generated_1.zodSelectDraw.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectDraw.shape, {
    drawDate: zod_1.z.coerce.date(),
    result: dbJsonModels_1.ZDrawTypeFullResult,
}));
exports.ZDrawTypeSelect = zodSchemas_generated_1.zodSelectDrawType.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectDrawType.shape, {
    numberSetup: dbJsonModels_1.ZEntryLine,
}));
exports.ZPlayerSelect = zodSchemas_generated_1.zodSelectPlayer;
exports.ZSubmitPrizeChoiceRequest = zod_1.z
    .object({
    prizeWinId: zod_1.z.string(),
    prizeId: zod_1.z.coerce.number(),
    productId: zod_1.z.coerce.number().optional(),
})
    .merge(exports.ZPrizeOrderInsert.pick({
    deliveryStreet: true,
    deliveryCity: true,
    deliveryPostcode: true,
    emailAddress: true,
    phoneNumber: true,
    additionalInfoFromPlayer: true,
}));
//# sourceMappingURL=models.js.map